export default {
    // récuperer toutes les guichets dans la base de données 
    get_all_commissions(serverParams){
        return axios.post('/commission/speciale/list?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },

    get_all_commissionsByEntite(serverParams){
        return axios.post('commission/speciale/entite/' + serverParams.entite_id+'?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_commissionsByTypeOperation(serverParams){
        return axios.post('commission/speciale/typeoperation/' + serverParams.typeoperation_code+'?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les guichets dans la base de données 
    post_commissions(commission){
        return axios.post('/commissions/speciales', commission, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_commissions(libelle, commission){
        return axios.put('/commissions/speciales/'+libelle,commission, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_commissions(libelle){
        return axios.get('/commissions/speciales/'+libelle, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_commissions(id){
        return axios.delete('/commissions/speciales/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

}